<template>
    <div v-if="show_playlist" class="quiz__campaign__endpoint-spotify-inner">
        <h2 class="quiz__campaign__endpoint-title">{{ content.title }}</h2>
        <div v-if="'null' != content.subtitle" class="quiz__campaign__endpoint_spotify-description" v-html="content.subtitle"></div>
        <div v-if="null !== playlist && playlist !== undefined" v-html="playlist.spotify" class="quiz__campaign__endpoint_spotify-player"></div>
        <div v-if="show_share === true" class="quiz__campaign__endpoint-share">
            <div>
                <a class="social-share" :href="'https://twitter.com/intent/tweet/?text=' + endpoint.title + '%20-%20' + campaign.links.start + '&amp;via='+twitterHandle+'&amp;hashtags=' + twitterHashtag" title="Share on Twitter" target="_blank">
                    <i class="icon-twitter">Twitter</i>
                </a>
                <a class="social-share" :href="'https://www.facebook.com/sharer/sharer.php?u=' + campaign.links.start" title="Share on Facebook" target="_blank">
                    <i class="icon-facebook">Facebook</i>
                </a>
                <a class="social-share" :href="'mailto:?&subject=' + endpoint.title + '&body='+ campaign.links.start" title="Share by Email">
                    <i class="icon-email">Email</i>
                </a>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['campaign', 'content','endpoint','spotifyshare'],
    mounted(){
        this.playlist = (this.content.data !== null) ? this.content.data[0] : '';
        if( this.spotifyshare == 1 )
        {
            this.show_share = true;
        }
        let localStorage = window.localStorage;
        this.answers = JSON.parse( localStorage.getItem('answers') );
        if(this.content.content_key != 0){
            this.show_playlist = false;
            let x = 0;
            for( x = 0; x < this.answers.other.length; x++)
            {
                let items = this.answers.other[x].split('_');
                if( items[1] == this.content.content_key )
                {
                    this.show_playlist = true;
                }
            }
            x = 0;
            for( x = 0; x < this.answers.content.length; x++)
            {
                let items = this.answers.content[x].split('_');

                if( items[1] == this.content.content_key )
                {
                    this.show_playlist = true;
                }
            }
            x = 0;
            for( x = 0; x < this.answers.journey.length; x++)
            {
                let items = this.answers.journey[x].split('_');
                if( items[1] == this.content.content_key )
                {
                    this.show_playlist = true;
                }
            }
            x = 0;

        } else {
            this.show_playlist = true;
        }

        if( this.show_playlist === false )
        {
            $('#content_block_'+ this.content.id).remove();
        }
    },
    computed: {
        twitterHashtag : function(){
            let accounts = this.endpoint.campaign.social_accounts;
            let hashtag;
            if( accounts !== null ){
                let max = this.endpoint.campaign.social_accounts.length;
                let x;
                for( x = 0; x < max; x++ ){
                    if( accounts[x].content == 'Twitter' )
                    {
                        hashtag = accounts[x].hashtag;
                    }
                }
            }
            return hashtag;
        },
        twitterHandle : function() {
            let accounts = this.endpoint.campaign.social_accounts;
            let handle;

                let max = this.endpoint.campaign.social_accounts.length;
                let x;

                for( x = 0; x < max; x++ ){
                    if( accounts[x].content == 'Twitter' )
                    {
                        handle = accounts[x].handle;
                    }
                }
            return handle;
        }
    },
    data() {
        return {
            show_playlist: false,
            playlist: null,
            show_share: false,
            answers: []
        }
    }

}
</script>


// WEBPACK FOOTER //
// resources/assets/js/quiz-campaign/components/content-blocks/spotify.vue